(function () {
  const LOADING_CLASS = "cart-empty-upsell-item__add--loading";

  function getItemRoot(element) {
    return element.closest(".cart-empty-upsell-item");
  }

  function getVariantId(item) {
    const select = item?.querySelector("[data-cart-empty-upsell-variant]");
    if (select) return select.value;

    const button = item?.querySelector(".cart-empty-upsell-item__add");
    return button?.dataset.variantId;
  }

  function getQuantity(item) {
    const input = item?.querySelector("[data-cart-empty-upsell-quantity]");
    const value = parseInt(input?.value || "1", 10);
    const min = parseInt(input?.min || "1", 10);
    const max = input?.max ? parseInt(input.max, 10) : null;
    let quantity = Number.isNaN(value) ? 1 : value;
    quantity = Math.max(min, quantity);
    if (max != null && !Number.isNaN(max)) quantity = Math.min(max, quantity);
    if (input) input.value = String(quantity);
    return quantity;
  }

  function getSectionsParam() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
      return cartDrawer.getSectionsToRender().map((section) => section.id).join(",");
    }
    return "cart-drawer,cart-icon-bubble";
  }

  function buildAddToCartConfig(formData) {
    const config =
      typeof fetchConfig === "function"
        ? fetchConfig("javascript")
        : {
            method: "POST",
            headers: {
              Accept: "application/javascript",
            },
          };

    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    config.body = formData;
    return config;
  }

  function refreshCartDrawer(data) {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) return;

    const isDrawerOpen = document.body.classList.contains("page-overlay-cart-on");

    if (typeof cartDrawer.renderContents === "function" && data.sections?.["cart-drawer"]) {
      cartDrawer.renderContents(
        {
          sections: data.sections,
          item_count: data.item_count,
        },
        !isDrawerOpen,
      );
      return;
    }

    if (typeof cartDrawer.openAfterAdd === "function") {
      cartDrawer.openAfterAdd(data);
      return;
    }

    if (typeof cartDrawer.refreshCartDrawer === "function") {
      cartDrawer.refreshCartDrawer();
    }
  }

  async function addUpsellToCart(button) {
    const item = getItemRoot(button);
    const variantId = getVariantId(item);
    if (!item || !variantId || button.disabled) return;

    const quantity = getQuantity(item);

    button.disabled = true;
    button.classList.add(LOADING_CLASS);

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", String(quantity));
    formData.append("sections", getSectionsParam());
    formData.append("sections_url", window.location.pathname);

    try {
      const response = await fetch(
        window.routes.cart_add_url,
        buildAddToCartConfig(formData),
      );

      const data = await response.json();

      if (data.status) {
        console.error("[cart-empty-upsell]", data.description || data.message);
        return;
      }

      if (typeof publish === "function") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-empty-upsell",
          productVariantId: variantId,
          cartData: data,
          itemCount: data.item_count,
        });
      }

      refreshCartDrawer(data);
    } catch (error) {
      console.error("[cart-empty-upsell]", error);
    } finally {
      button.disabled = false;
      button.classList.remove(LOADING_CLASS);
    }
  }

  function adjustQuantity(button, delta) {
    const item = getItemRoot(button);
    if (!item) return;

    const input = item.querySelector("[data-cart-empty-upsell-quantity]");
    if (!input) return;

    const step = parseInt(input.step || "1", 10) || 1;
    const min = parseInt(input.min || "1", 10) || 1;
    const max = input.max ? parseInt(input.max, 10) : null;
    let nextValue = parseInt(input.value || String(min), 10) + delta * step;

    if (Number.isNaN(nextValue)) nextValue = min;
    nextValue = Math.max(min, nextValue);
    if (max != null && !Number.isNaN(max)) nextValue = Math.min(max, nextValue);

    input.value = String(nextValue);
  }

  document.addEventListener("click", (event) => {
    const addButton = event.target.closest(".cart-empty-upsell-item__add");
    if (addButton) {
      event.preventDefault();
      event.stopPropagation();
      addUpsellToCart(addButton);
      return;
    }

    const decreaseButton = event.target.closest(".cart-empty-upsell-item__qty-decrease");
    if (decreaseButton) {
      event.preventDefault();
      adjustQuantity(decreaseButton, -1);
      return;
    }

    const increaseButton = event.target.closest(".cart-empty-upsell-item__qty-increase");
    if (increaseButton) {
      event.preventDefault();
      adjustQuantity(increaseButton, 1);
    }
  });

  document.addEventListener("change", (event) => {
    const select = event.target.closest("[data-cart-empty-upsell-variant]");
    if (!select) return;

    const item = getItemRoot(select);
    const button = item?.querySelector(".cart-empty-upsell-item__add");
    if (button) button.dataset.variantId = select.value;
  });
})();
